import m, {Vnode} from "mithril";
import {ImageItem} from "../../../../model/items/imageItem";
import ImageDialog from "./ImageDialog";

export default class Image {
    private readonly imageDialog: ImageDialog|null = null;

    constructor(
        private readonly imageItem: ImageItem
    ) {
        if (imageItem.previewType === ImageItem.PreviewType.CLICK_TO_FULL_IMAGE) {
            this.imageDialog = new ImageDialog(this.getUrl());
        }
    }

    private getUrl(): string {
        return this.imageItem.form.questionary.getFileUrl(this.imageItem.file);
    }

    public view(): Vnode|null {

        const visible = this.imageItem.cell.isVisible();
        if (!visible) {
            return null;
        }

        const cssClass = this.imageItem.cell.cssClass ? ('.'+this.imageItem.cell.cssClass) : '';
        const disabled = this.imageItem.cell.enabled ? '' : '.disabled';

        return m('.image'+disabled+cssClass, {}, [
            m("img"+(this.imageDialog?'.zoomable':''), {
                draggable: false,
                src: this.getUrl(),
                onclick: () => this.imageDialog?.showModal(),
            }),
            this.imageDialog ? m(this.imageDialog) : null
        ]);
    }

}
